import React from "react";
import "./CodeTerms.scss";
import { CodeTermsData } from "./CodeTermsData";
import { TextContent } from "../../../shared/TextContent/TextContent";
import StripedTable from "../../../shared/StripedTable/StripedTable.jsx";
import DynamicTable from "../../../shared/DynamicTable/DynamicTable.jsx";

function CodeTerms() {
  return (
    <section id="code-terms-section">
      <div className="section-container">
        <TextContent
          header={CodeTermsData.heading}
          description={CodeTermsData.description}
        />
        <br />
        <div>
          <DynamicTable
            title={CodeTermsData.table_header}
            columns={CodeTermsData.table_columns}
            data={CodeTermsData.table_data}
          />
        </div>
      </div>
    </section>
  );
}

export default CodeTerms;
